export const LABEL_DAY_USE = 'Day Use'
export const LABEL_TARIF_SAISONAL = 'Tarif saisonal'